import _ from 'lodash';
import axios from 'axios';
import UserProfile from '@/entities/UserProfile';

export default class UserService {
  constructor(authToken) {
    this.authToken = authToken;
    this.baseUrl = `${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/users`;
  }

  async createShopUser(userProfile, userPassword, shopId) {
    try {
      const url = this.baseUrl;
      const res = await axios.post(url,
        { ...userProfile, password: userPassword, shopIds: [shopId] },
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`,
          },
        });
      return new UserProfile(res.data.data);
    } catch (e) {
      return null;
    }
  }

  async softDeleteUser(userId) {
    try {
      const url = `${this.baseUrl}/${userId}`;
      const res = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${this.authToken}`,
        },
      });
      return res.data.data;
    } catch (e) {
      return null;
    }
  }

  async updateUser(userId, user) {
    try {
      const url = `${this.baseUrl}/${userId}`;
      const res = await axios.patch(url, { ...user }, {
        headers: {
          Authorization: `Bearer ${this.authToken}`,
        },
      });
      return res.data.data;
    } catch (e) {
      return null;
    }
  }

  async getUser(userId, userToken) {
    try {
      const url = `${this.baseUrl}/${userId}`;
      console.log('USER TOKEN', userToken);
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${this.authToken}`,
        },
      });
      const user = _.get(res, 'data.data');
      if (!user) { return null; }
      return new UserProfile(user);
    } catch (e) {
      return null;
    }
  }
}
